import fs from "fs/promises";
import path from "path";
import { loadEnvxFromString } from "../../src/core";
import { logger } from "../../shared/logger";

import { cyan, green, yellow, magenta, bold, white } from "colorette";

export async function print(options: { input: string }) {
  try {
    const inputPath = path.resolve(process.cwd(), options.input);
    const content = await fs.readFile(inputPath, "utf-8");

    const parsed = loadEnvxFromString(content);
    console.log(prettyPrintJson(parsed.result));
  } catch (err) {
    logger.error(`Error reading .envx file: ${err.message || err}`);
    process.exit(1);
  }
}

// <-----------------> #
// <---  HELPERS  ---> #
// <-----------------> #

function colorizeValue(value: any): string {
  if (value === null) return magenta("null");
  if (typeof value === "string") return green(`"${value}"`);
  if (typeof value === "number") return yellow(value.toString());
  if (typeof value === "boolean") return magenta(value.toString());
  return white(String(value));
}

function prettyPrintJson(obj: any, indent = 2): string {
  const space = " ".repeat(indent);

  function format(value: any, level: number): string {
    if (Array.isArray(value)) {
      if (value.length === 0) return "[]";
      const items = value
        .map((v) => space.repeat(level + 1) + format(v, level + 1))
        .join(",\n");
      return `[\n${items}\n${space.repeat(level)}]`;
    } else if (value && typeof value === "object") {
      const keys = Object.keys(value);
      if (keys.length === 0) return "{}";
      const props = keys
        .map(
          (key) =>
            `${space.repeat(level + 1)}${bold(cyan(`"${key}"`))}: ${format(
              value[key],
              level + 1
            )}`
        )
        .join(",\n");
      return `{\n${props}\n${space.repeat(level)}}`;
    } else {
      return colorizeValue(value);
    }
  }

  return format(obj, 0);
}
